<script setup>
import { onMounted, watch } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const accountId = useMapGetter('getCurrentAccountId');

onMounted(() => {
  store.dispatch('campaigns/get');
  store.dispatch('labels/get');
});

watch(accountId, (nextAccountId, previousAccountId) => {
  if (nextAccountId !== previousAccountId) {
    store.dispatch('campaigns/get');
    store.dispatch('labels/get');
  }
});
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-surface-1"
    data-testid="page-campaigns"
  >
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive" :key="accountId">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else :key="accountId" />
    </router-view>
  </div>
</template>
